<template>
  <section class="hero is-fullheight">
    <div class="createBody">
      <lateral-menu class="menuLateral" />
      <div class="container">
        <b-loading
          v-if="isLoading"
          :is-full-page="false"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <div>
          <tip
            v-if="this.account.canCreateOrganization"
            style="margin-top: .74rem;"
          />

          <div v-if="this.account.canCreateOrganization">
            <b-steps v-model="activeStep" class="step">
              <b-step-item step="1" label="Informações Principais">
                <main-info @input="updateLogo" />
                <pendencies :pendencies="mainInfoPendencies" />
              </b-step-item>

              <b-step-item step="2" label="Representantes">
                <leaders />
                <pendencies :pendencies="leadersPendencies" />
              </b-step-item>

              <b-step-item step="3" label="Integrantes">
                <team-members />
                <pendencies :pendencies="teamMembersPendencies" />
              </b-step-item>

              <b-step-item step="4" label="Atuação">
                <acting />
                <pendencies :pendencies="actingPendencies" />
              </b-step-item>

              <b-step-item step="5" label="Observações">
                <additional-info />

                <recommendation />

                <pendencies :pendencies="additionalInfoPendencies" />

                <div class="send">
                  <button
                    type="button"
                    class="button is-primary"
                    @click="createOrganization"
                    :disabled="additionalInfoPendencies.length > 0"
                  >
                    <b-icon icon="paper-plane"></b-icon>
                    &nbsp;&nbsp;&nbsp;&nbsp;Enviar
                  </button>
                </div>
              </b-step-item>

              <template #navigation="">
                <b-button
                  outlined
                  type="is-danger"
                  :disabled="previousDisabled"
                  @click.prevent="nextStep(-1)"
                  icon-left="backward"
                >
                  Voltar
                </b-button>

                <b-button
                  outlined
                  type="is-success"
                  :disabled="nextDisabled"
                  @click.prevent="nextStep(1)"
                  icon-right="forward"
                >
                  Próximo
                </b-button>
              </template>
            </b-steps>
          </div>

          <div class="columns" v-else>
            <div class="column has-text-centered">
              <h1 class="title is-3 is-spaced">
                Recebemos seu pedido de criação de OE!
              </h1>

              <h2 class="subtitle is-5">
                Por favor, verifique seu e-mail, enviamos os próximos passos
                para que você e sua Org. Estudantil possam se conectar com
                nossas Empresas Mentoras ;)
                <br />
                <br />
                Nossa equipe vai analisar seu cadastro em breve.
                <br />
                <br />
                <router-link to="/opportunities" tag="span" class="is-link">
                  <u>Voltar para Ações de Relacionamento</u>
                </router-link>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { commom } from "../../mixins/commom";
import { mask } from "../../mixins/mask";
import tip from "./commom/Tip";
import mainInfo from "./create-organization/MainInfo";
import leaders from "./create-organization/Leaders";
import teamMembers from "./create-organization/TeamMembers";
import acting from "./create-organization/Acting";
import recommendation from "./commom/Recommendation";
import additionalInfo from "./create-organization/AdditionalInfo";
import lateralMenu from "../lateral-menu/LateralMenu";
import pendencies from "../commom/Pendencies.vue";

export default {
  mixins: [commom, mask],

  components: {
    tip,
    mainInfo,
    leaders,
    teamMembers,
    acting,
    recommendation,
    additionalInfo,
    lateralMenu,
    pendencies
  },

  data() {
    return {
      isLoading: false,
      activeStep: 0,

      oe: {
        treatmentPronoun: "",
        name: "",
        organizationEmail: "",
        state: "",
        category: "",
        anotherCategory: "",
        city: "",
        fanpage: "",
        insta: "",
        linkedin: "",
        university: "",
        anotherUniversity: "",
        variousUniversities: "",
        objectives: "",
        hasProjects: "",
        projects: "",
        hasEvents: "",
        events: "",
        numberOfStudents: "",
        membersPerCourse: [
          {
            course: "",
            quantity: ""
          }
        ],
        numberOfWomenStudents: "",
        numberOfBlackStudents: "",
        numberOfLGBTStudents: "",
        otherMinorities: "",
        leader1: {
          name: "",
          position: "",
          email: "",
          areacode: "",
          cellphone: "",
          course: ""
        },
        leader2: {
          name: "",
          position: "",
          email: "",
          originalEmail: "",
          areacode: "",
          cellphone: "",
          course: ""
        },
        otherContacts: [
          {
            name: "",
            email: ""
          },
          {
            name: "",
            email: ""
          }
        ],
        recommendationName: "",
        recommendationContact: "",
        recommendationInstagram: "",
        empowerDiscovery: "",
        empowerDiscoveryOther: "",
        comments: ""
      },
      file: null
    };
  },

  methods: {
    createOrganization() {
      this.oe.fanpage = "https://www.facebook.com/" + this.oe.fanpage;
      this.oe.insta = "https://www.instagram.com/" + this.oe.insta;
      this.oe.linkedin = "https://www.linkedin.com/company/" + this.oe.linkedin;
      this.oe.leader2.originalEmail = this.oe.leader2.email;

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("oe", JSON.stringify(this.oe));

      this.isLoading = true;
      this.$store
        .dispatch("createOrganization", formData)
        .then(res => {
          if (res.data.result === "ok") {
            if (
              res.data.payload.oeCreationStatus === "WAITING_LEADER_2_VALIDATE_EMAIL" ||
              res.data.payload.oeCreationStatus === "WAITING_LEADER_2_SIGNUP"
            ) {
              this.alertError({ message: res.data.payload.oeCreationStatus });
            }
          } else {
            this.oe.fanpage = this.oe.fanpage.split(
              "https://www.facebook.com/"
            )[1];
            this.oe.insta = this.oe.insta.split(
              "https://www.instagram.com/"
            )[1];
            this.oe.linkedin = this.oe.linkedin.split(
              "https://www.linkedin.com/company/"
            )[1];
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.oe.fanpage = this.oe.fanpage.split(
            "https://www.facebook.com/"
          )[1];
          this.oe.insta = this.oe.insta.split("https://www.instagram.com/")[1];
          this.oe.linkedin = this.oe.linkedin.split(
            "https://www.linkedin.com/company/"
          )[1];
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateLogo(file) {
      this.file = file;
    },

    nextStep(n) {
      this.activeStep = this.activeStep + n;
    }
  },

  computed: {
    ...mapGetters(["account"]),

    isAnotherCategory() {
      return this.oe.category === "Outra";
    },

    previousDisabled() {
      return this.activeStep == 0 ? true : false;
    },

    nextDisabled() {
      let disabled = false;

      if (
        (this.activeStep === 0 && this.mainInfoPendencies.length) ||
        (this.activeStep === 1 && this.leadersPendencies.length) ||
        (this.activeStep === 2 && this.teamMembersPendencies.length) ||
        (this.activeStep === 3 && this.actingPendencies.length) ||
        this.activeStep === 4
      ) {
        disabled = true;
      }

      return disabled;
    },

    mainInfoPendencies() {
      const mainInfoPendencies = [];

      if (this.oe.treatmentPronoun == "") {
        mainInfoPendencies.push("Pronome");
      }
      if (this.oe.name == "") {
        mainInfoPendencies.push("Nome");
      }
      if (this.oe.category == "") {
        mainInfoPendencies.push("Categoria");
      }
      if (this.oe.organizationEmail == "") {
        mainInfoPendencies.push("E-mail");
      }
      if (this.oe.state == "") {
        mainInfoPendencies.push("UF (Estado)");
      }
      if (this.oe.city == "") {
        mainInfoPendencies.push("Cidade");
      }
      if (this.oe.university == "") {
        mainInfoPendencies.push("Universidade");
      }
      if (
        this.oe.fanpage == "" &&
        this.oe.insta == "" &&
        this.oe.linkedin == ""
      ) {
        mainInfoPendencies.push(
          "Pelo menos uma rede social (Facebook, Instagram ou Linkedin)"
        );
      }

      return mainInfoPendencies;
    },

    leadersPendencies() {
      const leadersPendencies = [];

      if (this.oe.leader1.position == "") {
        leadersPendencies.push("Posição do(a) representante 1");
      }

      if (this.oe.leader1.areacode == "") {
        leadersPendencies.push("DDD do(a) representante 1");
      }

      if (this.oe.leader1.cellphone == "") {
        leadersPendencies.push("Celular do(a) representante 1");
      }

      if (this.oe.leader2.email == "") {
        leadersPendencies.push("E-mail do(a) representate 2");
      }

      if (this.oe.leader2.name == "") {
        leadersPendencies.push("Nome do(a) representante 2");
      }

      if (this.oe.leader2.course == "") {
        leadersPendencies.push("Curso do(a) representante 2");
      }

      if (this.oe.leader2.position == "") {
        leadersPendencies.push("Posição do(a) representante 2");
      }

      if (this.oe.leader2.areacode == "") {
        leadersPendencies.push("DDD do(a) representante 2");
      }

      if (this.oe.leader2.cellphone == "") {
        leadersPendencies.push("Celular do(a) representante 2");
      }

      for (let i = 0; i < this.oe.otherContacts.length; i++) {
        if (this.oe.otherContacts[i].name == "") {
          leadersPendencies.push("Nome do(a) integrante " + (i + 1));
        }

        if (this.oe.otherContacts[i].email == "") {
          leadersPendencies.push("E-mail do(a) integrante " + (i + 1));
        }
      }

      return leadersPendencies;
    },

    teamMembersPendencies() {
      const teamMembersPendencies = [];

      if (this.oe.numberOfStudents == "" || this.oe.numberOfStudents == 0) {
        teamMembersPendencies.push("Número de integrantes da graduação");
      }
      for (let i = 0; i < this.oe.membersPerCourse.length; i++) {
        if (this.oe.membersPerCourse[i].course == "") {
          teamMembersPendencies.push("Nome do " + (i + 1) + "º curso");
        }
        if (
          this.oe.membersPerCourse[i].quantity == "" ||
          this.oe.membersPerCourse[i] == 0
        ) {
          teamMembersPendencies.push(
            "Quantidade de membros do " + (i + 1) + "º curso"
          );
        }
      }
      if (this.oe.numberOfWomenStudents == "") {
        teamMembersPendencies.push(
          "Número de mulheres (se não tiver, coloque 0)"
        );
      }
      if (this.oe.numberOfBlackStudents == "") {
        teamMembersPendencies.push(
          "Número de negros (se não tiver, coloque 0)"
        );
      }
      if (this.oe.numberOfLGBTStudents == "") {
        teamMembersPendencies.push(
          "Número de integrantes LGBTQIA+ (se não tiver, coloque 0)"
        );
      }
      return teamMembersPendencies;
    },

    actingPendencies() {
      const actingPendencies = [];

      if (this.oe.hasProjects === "") {
        actingPendencies.push("Sua OE realiza projetos?");
      }

      if (this.oe.hasProjects) {
        if (this.oe.projects == "") {
          actingPendencies.push(
            "Descrição dos projetos realizados pela sua OE"
          );
        }
      }

      if (this.oe.hasEvents === "") {
        actingPendencies.push("Sua OE realiza eventos?");
      }

      if (this.oe.hasEvents) {
        if (this.oe.events == "") {
          actingPendencies.push("Descrição dos eventos realizados pela sua OE");
        }
      }

      return actingPendencies;
    },

    additionalInfoPendencies() {
      const additionalInfoPendencies = [];

      if (this.oe.empowerDiscovery == "") {
        additionalInfoPendencies.push("Como você conheceu a Empower?");
      }

      if (this.oe.empowerDiscovery == "Outro") {
        if (this.oe.empowerDiscoveryOther == "") {
          additionalInfoPendencies.push("Qual outro?");
        }
      }

      return additionalInfoPendencies;
    }
  },

  mounted() {
    if (this.account.canCreateOrganization) {
      setTimeout(
        () =>
          this.$buefy.dialog.alert({
            title: "Importante!",
            message: `* Essas informações serão muito importantes para identificarmos maneiras específicas de contribuir
          para o aprimoramento dos projetos da sua OE, por isso, o formulário deve ser preenchido por um representante da OE.`,
            type: "is-warning",
            hasIcon: true,
            icon: "exclamation",
            iconPack: "fa"
          }),
        500
      );
    } else if (
      !this.account.canCreateOrganization &&
      !this.account.isOrganizationLeader
    ) {
      this.isLoading = false;
      this.$store
        .dispatch("checkOrganizationApproved")
        .then(res => {
          if (res.data.result === "ok") {
            if (res.data.payload.isOrganizationLeader === true) {
              this.$buefy.dialog.alert({
                title: "OE aprovada!",
                message:
                  "Agora, você já pode aproveitar todos os benefícios da plataforma ;)",
                type: "is-success",
                hasIcon: true,
                icon: "check",
                iconPack: "fa",
                onConfirm: () => this.$router.push("/editorganizationprofile"),
                onCancel: () => this.$router.push("/editorganizationprofile")
              });
            }
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }

    if (this.account.organizationTreatmentPronoun) {
      this.oe.treatmentPronoun = this.account.organizationTreatmentPronoun;
    }
    if (this.account.organizationName) {
      this.oe.name = this.account.organizationName;
    }
    if (this.account.organizationCategory) {
      this.oe.category = this.account.organizationCategory;
    }
  }
};
</script>

<style scoped>
section {
  background-color: #e9e9e9;
  padding-top: 4.37rem;
}
.step {
  background-color: white;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border-radius: 6px;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
    0 0 0 1px rgb(10 10 10 / 2%);
}
.send {
  max-width: 800px !important;
  margin: auto;
}
.is-link {
  cursor: pointer;
}
.createBody {
  width: fit-content;
  display: grid;
  grid-template-columns: auto auto;
  gap: 1rem;
  margin: auto;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.pendencies {
  margin-top: 1rem;
}

@media (min-width: 1024px) {
  .menuLateral {
    background-color: #e9e9e9;
  }
}
@media (max-width: 600px) {
  .step {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}
</style>
